<template>
    <div>

        <Divider :align="'left'">
            Базовые настройки
        </Divider>
        <div class="flex flex-row flex-wrap">
            <FormInput v-model="value.maxOpenDeals"
                       title="maxOpenDeals"
                       min="1" step="1"
                       description="Максимальное количество открытых сделок. Новые сделки выше этого значения совершаться не будут.
                       Отредактируйте, если предел достигнут, а деньги, которые вы хотите пустить в оборот, ещё есть."
            />

            <FormInput v-model="value.buyAmountUsd"
                       title="buyAmountUsd"
                       min="10" step="1"
                       description="Количество USDT, которое бот будет тратить при совершении сделки. Существует минимальное количество,
                       ниже которого Binance не даёт торговать, оно близко к 10."
            />

            <FormInput v-model="value.stopLoss"
                       title="stopLoss"
                       min="0" step="0.01"
                       description="Момент, когда продавать открытую сделку в убыток. 0 - никогда не продавать. 0.97 - продавать, когда курс упадёт на 3% от закупочного"
                       />
            <FormInput v-model="value.maxHoursOpenDeal"
                       title="maxHoursOpenDeal"
                       min="0" step="8"
                       description="Максимальное время в часах, сколько держать сделку открытой. После этого сделка закроется принудительно, со всей группой"
                       />
            <FormCheckbox v-model="value.sellOnlyProfitDeals"
                          title="sellOnlyProfitDeals"
                          description="Продавать по сигналу SELL только когда сделка закрывается в плюс." />
        </div>

        <Divider :align="'left'">
            Базовая средняя
        </Divider>
        <div class="flex flex-row flex-wrap">
            <FormInput v-model="value.jmaLength"
                title="jmaLength"
                min="1" step="5"
                description="Период jma" />
            <FormInput v-model="value.jmaPhase"
                title="jmaPhase"
                step="10"
                description="Фаза jma" />
            <FormInput v-model="value.jmaPower"
                title="jmaPower"
                min="1" step="1"
                description="Сила jma" />
        </div>

        <Divider :align="'left'">
            Канал покупки/продажи
        </Divider>
        <div class="flex flex-row flex-wrap">
            <FormInput v-model="value.atrLength"
                       title="atrLength"
                       min="1" step="1"
                       description="Период для определения atr" />
            <FormInput v-model="value.atrMultBuy"
                       title="atrMultBuy"
                       min="0.1" step="0.1"
                       description="Множитель границы для сигнала на покупку" />
            <FormInput v-model="value.atrMultSell"
                       title="atrMultSell"
                       min="0.1" step="0.1"
                       description="Множитель границы для сигнала на продажу" />

            <Divider layout="vertical" />

            <FormInput v-model="value.minWidthPercentile"
                        title="minWidthPercentile"
                        min="0" step="10"
                        description="Минимальный перцентиль ширины канала, разрешённый для покупки" />
            <FormInput v-model="value.widthPercentileLength"
                        title="widthPercentileLength"
                        min="10" step="10"
                        description="Период для определения пенцентиля ширины канала" />

            <Divider layout="vertical" />

            <FormInput v-model="value.maxBarsOutsideBand"
                        title="maxBarsOutsideBand"
                        min="1" step="1"
                        description="Максимальное число выходов за канал перед покупкой. Для предотвращения контртрендовых покупок на тренде." />
            <FormInput v-model="value.periodOutsideBand"
                        title="periodOutsideBand"
                        min="10" step="10"
                        description="Период для определения выходов за канал" />
        </div>

        <Divider :align="'left'">
            Быстрая средняя
        </Divider>
        <div class="flex flex-row flex-wrap">
            <FormInput v-model="value.fastLength"
                       title="fastLength"
                       min="1" step="1"
                       description="Период fast jma" />
            <FormInput v-model="value.fastPhase"
                       title="fastPhase"
                       step="10"
                       description="Фаза fast jma" />
            <FormInput v-model="value.fastPower"
                       title="fastPower"
                       min="1" step="1"
                       description="Сила fast jma" />
        </div>

        <Divider :align="'left'">
            Хэджирование
        </Divider>
        <div class="flex flex-row flex-wrap">
            <FormCheckbox v-model="value.allowHedge"
                          title="allowHedge"
                          description="Включить хеджирование" />
            <FormInput v-model="value.hedgeStartTimeframe"
                       title="hedgeStartTimeframe"
                       :show_controls="false"
                       description="Таймфрейм, на котором открываем хедж-сделки" />
            <FormInput v-model="value.hedgeStopTimeframe"
                       title="hedgeStopTimeframe"
                       :show_controls="false"
                       description="Таймфрейм, на котором закрываем хедж-сделки" />
            <FormInput v-model="value.hedgeMultAmount"
                       title="hedgeMultAmount"
                       min="1" step="0.1"
                       description="Множитель для buyAmountUsd для хэджирующей сделки" />
            <FormInput v-model="value.multAtrForStartHedge"
                       title="multAtrForStartHedge"
                       min="1" step="1"
                       description="Множитель для atrLength - падение цены, когда включать хеджирование" />
            <FormInput v-model="value.hedgeStopLoss"
                       title="hedgeStopLoss"
                       min="0" step="0.01"
                       description="Stop Loss для deals типа hedge" />
        </div>

    </div>
</template>

<script>
import InputNumber from "primevue/inputnumber";
import InputText from "primevue/inputtext";
import Divider from 'primevue/divider';
import Checkbox from 'primevue/checkbox';
import Dropdown from "primevue/dropdown";
import InputSwitch from "primevue/inputswitch";
import FormInput from "@/Settings/FormItems/FormInput.vue";
import FormCheckbox from "@/Settings/FormItems/FormCheckbox.vue";
export default {
    props: {
        value: Object,
        countOpenDeals: Number|null,
    },
    components:{
        FormCheckbox,
        FormInput,
        InputSwitch,
        Dropdown,
        InputNumber,
        InputText, Divider, Checkbox
    },
    data(){
        return {

        }
    },
    mounted(){

    },
    watch:{
        form(){
            this.$emit("input", this.form);
        }
    },
    methods:{
        incrementMaxDeals(){
            this.value.maxOpenDeals++;
        },
        decrementMaxDeals(){
            this.value.maxOpenDeals--;
            if(this.value.maxOpenDeals < 0){
                this.value.maxOpenDeals = 0;
            }
        }
    }
}
</script>
